import React from "react";
import PropTypes from "prop-types";
import Image from "next/image";

const CardIcon = (props: {
  icon: any;
  title: string;
  description: string;
  link?: string;
  imgHeight?: number;
  imgWidth?: number;
  sizes?: string;
  quality?: number;
}) => {
  return (
    <>
      <div className={"card-icon"}>
        {props?.imgHeight && props?.imgWidth ? (
          <Image
            src={props.icon}
            alt={props.title}
            width={props.imgWidth}
            height={props.imgHeight}
            sizes={props.sizes ?? "(max-width:768px) 80px, 107px"}
            quality={props.quality ?? 55}
          />
        ) : (
          <img src={props.icon} alt={props.title} width={100} height={100} />
        )}
        <h4>{props.title}</h4>
        <p>{props.description}</p>
      </div>
    </>
  );
};
CardIcon.defaultProps = {
  icon: "",
  title: "20%",
  description:
    "Enhanced clarity and real-time log monitoring accelerate bug detection and resolution.",
  link: null,
};
CardIcon.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
};
export default CardIcon;
